export default __webpack_public_path__ + "static/media/afric4.cb7bf2cc.png";